document.addEventListener('DOMContentLoaded', function() {
  const searchForms = document.querySelectorAll('.header-search-form');
  const mobileSearchToggle = document.querySelector('.mobile-search .header-search-toggle');
  const body = document.body;
  const headerSearchInput = document.getElementById('main-header-search-input');
  const popupSearchInput = document.getElementById('header-search-input');
  
  if (mobileSearchToggle) {
    mobileSearchToggle.addEventListener('click', function(event) {
      event.preventDefault();
      
      const searchForm = document.querySelector('.header-search-form:not(.header-form)');
      
      let searchOverlay = document.querySelector('.mobile-search-overlay');
      if (!searchOverlay) {
        searchOverlay = document.createElement('div');
        searchOverlay.className = 'mobile-search-overlay';
        body.appendChild(searchOverlay);
      }
      
      searchOverlay.classList.add('active');
      searchForm.classList.add('mobile-active');
      searchForm.style.display = 'block';
      searchForm.style.position = 'fixed';
      searchForm.style.top = '0';
      searchForm.style.left = '0';
      searchForm.style.right = '0';
      searchForm.style.zIndex = '999';
      searchForm.style.margin = '10px';
      
      const searchBar = searchForm.querySelector('#header-search-bar');
      if (searchBar) searchBar.style.width = '100%';
      
      const searchInput = searchForm.querySelector('#header-search-input');
      if (searchInput) {
        searchInput.style.width = '100%';
        searchInput.style.padding = '12px 15px';
        searchInput.style.fontSize = '16px';
        
        // Enfocar el campo de búsqueda
        setTimeout(() => {
          searchInput.focus();
        }, 100);
      }
      
      // Configurar cerrado del overlay
      searchOverlay.addEventListener('click', function() {
        closeSearch();
      });
    });
  }
  
  // Función para cerrar la búsqueda móvil
  function closeSearch() {
    const searchOverlay = document.querySelector('.mobile-search-overlay');
    const searchForm = document.querySelector('.header-search-form.mobile-active');
    
    if (searchOverlay) {
      searchOverlay.classList.remove('active');
    }
    
    if (searchForm) {
      searchForm.classList.remove('mobile-active');
      // Eliminar estilos inline al cerrar
      searchForm.style.display = '';
      searchForm.style.position = '';
      searchForm.style.top = '';
      searchForm.style.left = '';
      searchForm.style.right = '';
      searchForm.style.zIndex = '';
      searchForm.style.margin = '';
      
      const searchBar = searchForm.querySelector('#header-search-bar');
      if (searchBar) searchBar.style.width = '';
      
      const searchInput = searchForm.querySelector('input[type="search"]');
      if (searchInput) {
        searchInput.style.width = '';
        searchInput.style.padding = '';
        searchInput.style.fontSize = '';
      }
    }
  }

  function performSearch(searchInput, form, resultsContainer) {
    const searchTerm = searchInput.value.trim();
    
    if (searchTerm.length >= 1) {
      form.classList.add('active');
      
      let resultsDropdown = form.querySelector('.header-search-results-dropdown');
      if (!resultsDropdown) {
        resultsDropdown = document.createElement('div');
        resultsDropdown.className = 'header-search-results-dropdown';
        
        if (!resultsContainer) {
          const newResultsContainer = document.createElement('div');
          newResultsContainer.className = 'header-search__results';
          resultsDropdown.appendChild(newResultsContainer);
          form.appendChild(resultsDropdown);
          resultsContainer = newResultsContainer;
        } else {
          resultsDropdown.appendChild(resultsContainer);
          form.appendChild(resultsDropdown);
        }
      }
      
      if (window.innerWidth <= 768 && form.classList.contains('mobile-active')) {
        resultsDropdown.style.display = 'block';
        resultsDropdown.style.position = 'fixed';
        resultsDropdown.style.top = '60px';
        resultsDropdown.style.left = '10px';
        resultsDropdown.style.right = '10px';
        resultsDropdown.style.maxHeight = 'calc(100vh - 70px)';
        resultsDropdown.style.overflowY = 'auto';
        resultsDropdown.style.zIndex = '1000';
      }
      
      resultsContainer.innerHTML = '<div class="loading-container"><div class="loading-spinner"></div></div>';
      
      fetch(`/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product`)
        .then(response => response.json())
        .then(data => {
          displayResults(data.resources.results.products, resultsContainer, searchTerm);
        })
        .catch(error => {
          console.error('Error en la búsqueda:', error);
          resultsContainer.innerHTML = '<div class="no-results">Error al buscar productos</div>';
        });
    } else {
      form.classList.remove('active');
      resultsContainer.innerHTML = '';
      
      const resultsDropdown = form.querySelector('.header-search-results-dropdown');
      if (resultsDropdown) {
        resultsDropdown.style.display = '';
        resultsDropdown.style.position = '';
        resultsDropdown.style.top = '';
        resultsDropdown.style.left = '';
        resultsDropdown.style.right = '';
        resultsDropdown.style.maxHeight = '';
        resultsDropdown.style.overflowY = '';
      }
    }
  }
  
  // Configurar cada formulario de búsqueda
  searchForms.forEach(form => {
    // Crear botón de cierre si no existe para formularios móviles
    if (!form.querySelector('.mobile-search-close')) {
      const closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'mobile-search-close';
      closeButton.innerHTML = '×';
      closeButton.setAttribute('aria-label', 'Cerrar búsqueda');
      closeButton.style.display = 'none'; // Inicialmente oculto
      
      closeButton.addEventListener('click', function() {
        closeSearch();
      });
      
      const searchBar = form.querySelector('#header-search-bar');
      if (searchBar) {
        searchBar.appendChild(closeButton);
      }
    }
    
    // Identificar los elementos específicos para cada formulario
    const searchInput = form.querySelector('input[type="search"]');
    const resultsContainer = form.querySelector('.header-search__results');
    const closeButton = form.querySelector('.mobile-search-close');
    
    if (!searchInput || !resultsContainer) return;
    
    if (window.innerWidth <= 768 && form.classList.contains('mobile-active') && closeButton) {
      closeButton.style.display = 'block';
    }
    
    searchInput.addEventListener('input', function() {
      performSearch(this, form, resultsContainer);
    });
    
    searchInput.addEventListener('focus', function() {
      if (this.value.trim().length >= 1) {
        performSearch(this, form, resultsContainer);
      }
      
      // Código específico para el header
      if (form.classList.contains('header-form')) {
        const searchBar = form.querySelector('.header-search-bar');
        if (searchBar) {
          searchBar.style.width = window.innerWidth >= 1025 ? '370px' : '250px';
        }
        searchInput.style.width = window.innerWidth >= 1025 ? '330px' : '210px';
      }
    });
    
    document.addEventListener('click', function(event) {
      if (!form.contains(event.target) && !event.target.closest('.mobile-search')) {
        form.classList.remove('active');
      }
    });
    
    form.addEventListener('submit', function(event) {
      if (searchInput.value.trim() === '') {
        event.preventDefault();
      }
    });
    
    // Configuración específica para la barra del header (no popup)
    if (form.classList.contains('header-form')) {
      // Restaurar ancho al perder foco, pero solo si no hay resultados activos
      searchInput.addEventListener('blur', function() {
        // Añadimos un retraso pequeño para permitir clics en los resultados
        setTimeout(() => {
          const resultsVisible = form.classList.contains('active');
          if (!resultsVisible) {
            const searchBar = form.querySelector('.header-search-bar');
            if (searchBar) {
              searchBar.style.width = '';
            }
            searchInput.style.width = '';
          }
        }, 200);
      });
    }
  });
  
  window.addEventListener('resize', function() {
    const searchForm = document.querySelector('.header-search-form.mobile-active');
    if (searchForm) {
      const closeButton = searchForm.querySelector('.mobile-search-close');
      if (closeButton) {
        closeButton.style.display = window.innerWidth <= 768 ? 'block' : 'none';
      }
    }
    
    const headerForm = document.querySelector('.header-form');
    if (headerForm && headerForm.contains(document.activeElement)) {
      const searchBar = headerForm.querySelector('.header-search-bar');
      const searchInput = headerForm.querySelector('input[type="search"]');
      
      if (searchBar && searchInput) {
        if (window.innerWidth >= 1025) {
          searchBar.style.width = '370px';
          searchInput.style.width = '330px';
        } else if (window.innerWidth >= 769) {
          searchBar.style.width = '250px';
          searchInput.style.width = '210px';
        }
      }
    }
  });
  
  function displayResults(products, container, searchTerm) {
    if (!products || products.length === 0) {
      container.innerHTML = '<div class="no-results">No se encontraron productos</div>';
      return;
    }
    
    let html = '';
    products.slice(0, 5).forEach(product => {
      const imageUrl = product.image || (product.featured_image ? product.featured_image.url : 'https://cdn.shopify.com/s/files/1/0706/9938/5075/files/no-image.jpg');
      
      const optimizedImageUrl = imageUrl.includes('?') 
        ? `${imageUrl}&width=100&height=100&crop=center` 
        : `${imageUrl}?width=100&height=100&crop=center`;
      
      let priceHtml = '';
      
      if (product.price_min !== undefined) {
        const price = formatPriceToActualCLP(product.price_min);
        let comparePrice = null;
        
        if (product.compare_at_price_min && product.compare_at_price_min > product.price_min) {
          comparePrice = formatPriceToActualCLP(product.compare_at_price_min);
          priceHtml = `
            <div class="search-result__price-wrapper">
              <span class="search-result__price search-result__price--sale">${price}</span>
              <span class="search-result__compare-price">${comparePrice}</span>
            </div>
          `;
        } else {
          priceHtml = `<div class="search-result__price">${price}</div>`;
        }
      }
      
      html += `
        <div class="search-result">
          <a href="${product.url}" class="search-result__link">
            <div class="search-result__image">
              <img src="${optimizedImageUrl}" alt="${product.title}" loading="lazy">
            </div>
            <div class="search-result__detail">
              <div class="search-result__title">${product.title}</div>
              ${priceHtml}
            </div>
          </a>
        </div>
      `;
    });
    
    if (products.length > 5) {
      html += `<div class="search-result view-all">
        <a href="/search?q=${encodeURIComponent(searchTerm)}" class="search-result__link">
          Ver todos los resultados
        </a>
      </div>`;
    }
    
    container.innerHTML = html;
  }
  
  // FUNCIÓN REPARADA - Mostrar precio tal como llega de la API
  function formatPriceToActualCLP(price) {
    // Debug: Mostrar en consola el precio exacto que llega
    console.log('Precio recibido de Shopify API:', price);
    
    // Solo formatear con puntos de miles, SIN modificar el valor
    const formattedPrice = '$' + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    
    console.log('Precio final mostrado:', formattedPrice);
    return formattedPrice;
  }
  
  const originalSearchToggles = document.querySelectorAll('.header-search-toggle:not(.mobile-search .header-search-toggle)');
  originalSearchToggles.forEach(toggle => {
    toggle.addEventListener('click', function(event) {
      event.preventDefault();
      const mainSearchInput = document.getElementById('main-header-search-input');
      if (mainSearchInput) {
        mainSearchInput.focus();
      } else {
        const popupSearchInput = document.getElementById('header-search-input');
        if (popupSearchInput) {
          popupSearchInput.focus();
        }
      }
    });
  });
  
  const popupTriggers = document.querySelectorAll('[data-open-search-popup]');
  popupTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(event) {
      event.preventDefault();
      const popup = document.getElementById('popup');
      if (popup) {
        popup.style.display = 'block';
        const popupSearchInput = document.getElementById('header-search-input');
        if (popupSearchInput) {
          setTimeout(() => {
            popupSearchInput.focus();
          }, 100);
        }
      }
    });
  });
  
  window.closePopup = function() {
      const popup = document.getElementById('popup');
      if (popup) {
        popup.style.display = 'none';
      }
    };
});

// Código adicional para el placeholder del input principal
const searchInput = document.getElementById('main-header-search-input');
if (searchInput) {
  const originalPlaceholder = searchInput.placeholder;

  searchInput.addEventListener('focus', function() {
    this.placeholder = '¿Qué estás buscando?';
  });

  searchInput.addEventListener('blur', function() {
    setTimeout(() => {
      this.placeholder = originalPlaceholder;
    }, 200); 
  });
}